import React, { FC } from 'react'

import { IconWifiGoodProps } from './IconWifiGood.types'
import * as Styled from './styles/IconWifiGood.style'

import { nonThemeableRules } from '../../ruleSet'

const IconWifiGood: FC<IconWifiGoodProps> = ({
  size = nonThemeableRules.defaultSize as number as IconWifiGoodProps['size'],
  isResponsive = false,
}: IconWifiGoodProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M5.02 19A26.858 26.858 0 0 1 43 18.983l.017.017'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M10.523 25a19.183 19.183 0 0 1 27.134-.015l.016.015M16.17 30.965a11.155 11.155 0 0 1 15.775 0'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24.02 39.063a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24.02 38.688a.625.625 0 1 0 0-1.25.625.625 0 0 0 0 1.25Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M24.02 38.313a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Z'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M25.45 38.063a1.43 1.43 0 1 1-2.86 0 1.43 1.43 0 0 1 2.86 0Z' fill='#fff' stroke='#EA1A1A' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconWifiGood
